/**
 * Utils
 */
import { af_utils } from "../index/utils";

/**
 * Cookie name constant
 */
const COOKIE_NAME = 'alfaleads-cookies';

/**
 * DOM elements
 */
let $bar;
let $declineBtn;
let $agreeBtn;
let $showMoreBtn;
let $firstStepText;
let $secondStepText;

/**
 * Check if cookies agreement exist
 */
const checkCookies = () => af_utils.getCookie(COOKIE_NAME);

/**
 * Set cookies agreement value
 * @param {boolean} boolean has agreed
 */
const setCookies = (boolean) => {
  af_utils.setCookie(COOKIE_NAME, boolean, 1000);
  $bar.remove();

  if (boolean) initTrackers();
}

const showMoreHandler = (e) => {
  e.preventDefault();
  $firstStepText.addClass('cookies-bar__intro--hidden');
  $secondStepText.addClass('cookies-bar__full--visible');
}

/**
 * Create script helper
 */
const createScript = (url) => {
  const script = document.createElement('script');
  script.src = url;
  document.body.appendChild(script);
};

/**
 * Google tag init
 */
const initGoogleTag = () => {
  const script = document.createElement('script');
  script.text = '(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({\'gtm.start\':\n' +
    'new Date().getTime(),event:\'gtm.js\'});var f=d.getElementsByTagName(s)[0],\n' +
    'j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';j.async=true;j.src=\n' +
    '\'https://www.googletagmanager.com/gtm.js?id=\'+i+dl;f.parentNode.insertBefore(j,f);\n' +
    '})(window,document,\'script\',\'dataLayer\',\'GTM-KSF8KJD\');'
  document.head.appendChild(script);
};

/**
 * Init sendpulse request
 */
const initSendPulse = () => {
  const css = document.createElement('link');
  css.src = '/css/vendors/sendpulse-prompt.css';
  css.rel = 'stylesheet';
  css.type = 'text/css';
  document.head.appendChild(css);

  createScript('//cdn.sendpulse.com/js/push/9dd2fdfa2517c3c1bccc17b992610efc_1.js');
}

/**
 * Init all trackers
 */
const initTrackers = () => {
  /** Google Tag Manager */
  // initGoogleTag();

  /** Sendpulse */
  initSendPulse();

  /** Mail */
  createScript('/js/tracking/mailru.js');

  /** VK Open API */
  createScript('/js/tracking/openapi.js');
}

/**
 * Expo
 */
export const initCookiesBar = () => {

  /** Bind DOM elements */
  $bar = $('.cookies-bar');
  $declineBtn = $('.cookies-bar__btn--decline');
  $agreeBtn = $('.cookies-bar__btn--agree');
  $showMoreBtn = $('.cookies-bar__show-more');
  $firstStepText = $('.cookies-bar__intro');
  $secondStepText = $('.cookies-bar__full');

  /** Check cookie agreement */
  const isAgreed = checkCookies();

  if (isAgreed === undefined) {
    $bar.addClass('cookies-bar--visible');
    $declineBtn.on('click', setCookies.bind(null, false));
    $agreeBtn.on('click', setCookies.bind(null, true));
    $showMoreBtn.on('click', showMoreHandler);

  } else {
    $bar.remove();

    if (isAgreed === 'true') {
      initTrackers();
    }
  }
}
